define('controllers/aplpromote/cloud-folder-promote-add.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('cFPromoteAddCtrl', ['$q','$scope', '$state', 'OpenApp', 'OpenOther','OpenTrade', 'auiBalanceService','UserInfo', '$stateParams', 'auiDialog',
        'InAppNew', '$filter', '$rootScope','HiCloudFolder','getAppParameter',
        function ($q,$scope, $state, OpenApp, OpenOther,OpenTrade,auiBalanceService, UserInfo, $stateParams, auiDialog, InAppNew, $filter, $rootScope,HiCloudFolder,getAppParameter) {



            var Model = $scope.Model = {
                appInfo : '',
                appList : [],
                taskId : $stateParams.taskId,
                innewappType : 51
            };


            //新建任务面板模型
            $scope.CreateNewModel = {
                CloudFolderTask: {},
                taskName: '',
                minTime: new Date()
            };


            //视图中绑定方法
            $scope.Method = {
                goToList: goToList,
                isEmptyObj: isEmptyObj,
                submitCfpTaskFun: submitCfpTaskFun,
                queryCfpTaskDetail: queryCfpTaskDetail
            };

            //初始化函数
            function init() {
                getSystemParam();
                getAppParameter.getUp().then(function () {
                    queryAgentAppList().then(function(){
                        $scope.CreateNewModel.CloudFolderTask.startTime = new Date();
                        $scope.CreateNewModel.CloudFolderTask.endTime = AUI.DateUtil.calDaysLater(new Date(), Model.minPeriod - 1);

                        if(Model.taskId && Model.taskId !=0 ){
                            queryCfpTaskDetail(Model.taskId);
                        }

                            // 查询余额
                            getNewBalance();
                    });
                });
            }

            // 查询系统参数
            function getSystemParam() {
                InAppNew.queryCfpConfig().then(function (data) {
                    if (data && data.config && data.retCode == 0) {
                        Model.minPrice = Number(data.config.minPrice);
                        Model.minBudget = Number(data.config.minBudget);
                        Model.minPeriod = Number(data.config.minPeriod);
                        Model.maxPeriod = Number(data.config.maxPeriod);

                    } else {
                        showErrorDialog(data.retCode, '获取云文件夹推广系统参数失败。', function () {
                            $state.go('aplPromoteCFList');
                        });
                    }
                }).catch(function (data) {
                    if (data && data.retCode) {
                        showErrorDialog(data.retCode, '获取云文件夹推广系统参数失败。', function () {
                            $state.go('aplPromoteCFList');
                        });
                    }
                });
            }

            //获取被推广应用的列表
            function queryAgentAppList(){
                var defer = $q.defer();
                HiCloudFolder.queryAgentAppList({
                    request:{
                        start : 0
                    }
                }).then(function(data) {
                    if (data && data.totalCount > 0) {
                        Model.appList = data.agency;
                    }
                    defer.resolve();
                }).catch(function (data) {
                    if (data && data.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                    }else if(data && data.retCode){
                        showErrorDialog(data.retCode, '获取被推广应用的列表失败。', function () {
                            $state.go('aplPromoteCFList');
                        });
                    }
                    defer.reject();
                });
                return defer.promise;
            }

            function submitCfpTaskFun(type) {
                var defer = $q.defer();
                $scope.cfpTaskForm.$setDirty();
                $scope.cfpTaskForm.taskName.$setDirty();
                $scope.cfpTaskForm.appInfo.$setDirty();
                $scope.cfpTaskForm.price.$setDirty();
                $scope.cfpTaskForm.budget.$setDirty();
                $scope.cfpTaskForm.startTime.$setDirty();
                $scope.cfpTaskForm.endTime.$setDirty();

                if($scope.cfpTaskForm.$invalid ||
                    $scope.cfpTaskForm.taskName.$invalid ||
                    $scope.cfpTaskForm.price.$invalid ||
                    $scope.cfpTaskForm.budget.$invalid ||
                    $scope.cfpTaskForm.startTime.$invalid ||
                    $scope.cfpTaskForm.endTime.$invalid){
                    return;
                }

                var submitData = angular.copy($scope.CreateNewModel.CloudFolderTask);
                submitData.appId = $scope.Model.appInfo.appId;
                submitData.appPackageName = $scope.Model.appInfo.packageName;
                submitData.appName = $scope.Model.appInfo.appCNName;
                submitData.appIconUrl = $scope.Model.appInfo.iconUrl;
                submitData.cloudFolderId = $scope.Model.appInfo.folderId;
                submitData.startTime = AUI.DateUtil.date2Str(submitData.startTime);
                submitData.endTime = AUI.DateUtil.date2Str(submitData.endTime);
                submitData.price = '' + submitData.price;
                submitData.budget = '' + submitData.budget;
                submitData.priceType = 'CPD';

                if($scope.Model.appInfo.childType && $scope.Model.appInfo.grandchildType){
                    getAppParameter.get().forEach(function (v) {
                        if (v.ID == $scope.Model.appInfo.childType) {
                            v.subKind.forEach(function (k) {
                                if (k.ID == $scope.Model.appInfo.grandchildType) {
                                    submitData.appCategory = k.name;
                                }
                            });
                        }
                    });
                }

                // 草稿
                if (type == 1) {
                    if (submitData.status == 'RUN') {
                        auiDialog.fail("执行状态的任务请直接提交审核。");
                        return false;
                    }
                    submitData.status = 'CREATIVE PENDING';
                    commitCFPTask(submitData, '保存草稿').then(function(){
                        defer.resolve();
                    }).catch(function(){
                        defer.reject();
                    });
                }
                // 提交审核
                if (type == 2) {
                    if (submitData.status == 'RUN') {
                        updateCFPTask(submitData, '提交审核').then(function(){
                            defer.resolve();
                        }).catch(function(){
                            defer.reject();
                        });
                    } else {
                        submitData.status = 'AUDIT PENDING';
                        commitCFPTask(submitData, '提交审核').then(function(){
                            defer.resolve();
                        }).catch(function(){
                            defer.reject();
                        });
                    }
                }
                return defer.promise;
            }

            function commitCFPTask(submitData, operateText) {
                var defer = $q.defer();
                // 参数
                var paramInf = {
                    task: submitData
                };

                InAppNew.addCfpTask(paramInf).then(function (data) {
                    if (data && data.retCode == 0) {
                        $scope.modFlag = $rootScope.modFlag = false;
                        if(submitData.status == 'AUDIT PENDING'){//区分提交审核与保存草稿
                            auiDialog.successAndMark(operateText + '成功。', function () {
                                $state.go('aplPromoteCFList');
                            },{isOnShelf:"1"});
                        }else{
                            auiDialog.success(operateText + '成功。', function () {
                                $state.go('aplPromoteCFList');
                            });
                        }

                    } else {
                        showErrorDialog(data.retCode, operateText + '失败。');
                    }
                    defer.resolve();
                }).catch(function (data) {
                    if (data && data.errorCode) {
                        showErrorDialog(data.retCode, operateText + '失败。');
                    }
                    defer.reject();
                });
                return defer.promise;
            }

            function updateCFPTask(submitData, operateText) {
                var defer = $q.defer();
                // 参数
                var submitDataTemp = {};
                submitDataTemp.taskId = submitData.taskId;
                submitDataTemp.price = submitData.price;
                submitDataTemp.budget = submitData.budget;
                submitDataTemp.endTime = submitData.endTime;

                InAppNew.modifyCfpTask(submitDataTemp).then(function (data) {
                    if (data && data.retCode == 0) {
                        $scope.modFlag = $rootScope.modFlag = false;
                        auiDialog.successAndMark(operateText + '成功。', function () {
                            $state.go('aplPromoteCFList');
                        },{isOnShelf:"2"});
                    } else {
                        showErrorDialog(data.retCode, operateText + '失败。');
                    }
                    defer.resolve();
                }).catch(function (data) {
                    if (data && data.retCode) {
                        showErrorDialog(data.retCode, operateText + '失败。');
                    }
                    defer.reject();
                });
                return defer.promise;
            }

            function showErrorDialog(code, infoDefault, callBack) {
                var info = {
                        403: '很抱歉，您的帐号已失效。',
                        410: '很抱歉，您的帐号已被管理员冻结。',
                        720: '鲸鸿动能广告投放基金余额不足。',
                        721: '不能创建同时间段内的推广任务。',
                        750: '该产品已有推广任务(草稿/审核中/审核不通过/执行)。',
                        1000000006: '联盟登录优易点失败，请稍候重试。'
                    }[code] || infoDefault ||'请求失败，请稍候重试。';
                if (callBack) {
                    auiDialog.fail(info, callBack);
                } else {
                    auiDialog.fail(info);
                }
            }

            function queryCfpTaskDetail(taskId) {
                // 参数
                var paramInf = {
                    taskId: taskId
                };
                InAppNew.getCfpTasKDetail(paramInf).then(function (data) {
                    if (data && data.retCode == 0) {
                        $scope.CreateNewModel.CloudFolderTask = data.taskDetail;
                        $scope.CreateNewModel.CloudFolderTask.price = parseFloat(data.taskDetail.price);
                        $scope.CreateNewModel.CloudFolderTask.budget = parseInt(data.taskDetail.budget);
                        $scope.CreateNewModel.CloudFolderTask.startTime = AUI.DateUtil.stringToDate(data.taskDetail.startTime);
                        $scope.CreateNewModel.CloudFolderTask.endTime = AUI.DateUtil.stringToDate(data.taskDetail.endTime);
                        $scope.CreateNewModel.CloudFolderTask.oldBudget = parseInt(data.taskDetail.budget);
                        $scope.CreateNewModel.CloudFolderTaskBackUp = angular.copy($scope.CreateNewModel.CloudFolderTask);
                        if(data.taskDetail.appId){
                            Model.appList.forEach(function(v){
                                if(v.appId == data.taskDetail.appId){
                                    Model.appInfo = v;
                                }
                            });
                            if(!Model.appInfo){
                                auiDialog.fail("该应用暂不能再进行云文件夹推广，请联系qinjuan1@huawei.com或hifolder@huawei.com咨询。");
                            }
                        }

                        if ($scope.CreateNewModel.CloudFolderTask.status == 'RUN') {
                            $scope.CreateNewModel.CloudFolderTask.startTimeRun = AUI.DateUtil.date2Str(data.taskDetail.startTime);
                        } else if (AUI.DateUtil.calDaysDual($scope.CreateNewModel.CloudFolderTask.startTime, new Date()) < 1) {
                            auiDialog.fail('开始时间已过期，设为今日？', function () {
                                $scope.CreateNewModel.CloudFolderTask.startTime = new Date();
                            });
                        }
                    } else {
                        showErrorDialog(data.retCode, '获取任务详情失败。');
                    }

                }).catch(function (data) {
                    if (data && data.retCode) {
                        showErrorDialog(data.retCode, '获取任务详情失败。');
                    }
                });
            }

            //逻辑函数调用开始

            init();


            function getBalance() {
                InAppNew.queryBalance().then(function (data) {
                    if (data && data.retCode == 0) {
                        Model.balance = Number(data.balance);
                    } else {
                        showErrorDialog(data.retCode, '获取推广基金余额失败。');
                    }
                }).catch(function (data) {
                    if (data && data.retCode) {
                        showErrorDialog(data.retCode, '获取推广基金余额失败。');
                    }
                });
            }

            function getNewBalance() {
                var queryBalanceReq = {
                    version: '1.0',
                    traceUniqueID: auiBalanceService.getTraceUniqueID()
                };
                //获取金额
                OpenTrade.getBalance({req: queryBalanceReq},true).then(function (data) {
                    //云文件夹总金额(现金+资源置换+赠送)
                    Model.balance = 0;

                    if (data.accountInfos && data.accountInfos.length > 0) {
                        angular.forEach(data.accountInfos, function (account) {
                            //现金
                            if (account.accountType == 1) {
                                angular.forEach(account.balances, function (balance) {
                                    //云文件夹
                                    if (balance.serviceItem == Model.innewappType) {
                                        Model.balance += balance.validBalance;
                                    }

                                });
                            }
                            //资源置换
                            else if (account.accountType == 2) {
                                angular.forEach(account.balances, function (balance) {
                                    //云文件夹
                                    if (balance.serviceItem == Model.innewappType) {
                                        Model.balance += balance.validBalance;
                                    }
                                });
                            }
                            //纯赠送
                            else if (account.accountType == 3 || account.accountType == 4) {
                                angular.forEach(account.balances, function (balance) {
                                    //云文件夹
                                    if (balance.serviceItem == Model.innewappType) {
                                        Model.balance += balance.validBalance;
                                    }
                                });
                            }
                        });
                    }
                    Model.balance = $filter('auiMoneyChangeFilter')(Model.balance);

                });

            }

            function goToList() {
                $state.go('aplPromoteCFList');
            }

            function isEmptyObj(obj) {
                for (var key in obj) {
                    return false;
                }
                return true;
            }

            $scope.$watch('CreateNewModel.CloudFolderTask', function (newTask, oldTask) {
                var backupTask = $scope.CreateNewModel.CloudFolderTaskBackUp;
                $scope.modFlag = $rootScope.modFlag = !backupTask || (backupTask.taskName != newTask.taskName || backupTask.price != newTask.price || backupTask.budget != newTask.budget
                || AUI.DateUtil.calDaysDual(backupTask.startTime, newTask.startTime) != 1 || AUI.DateUtil.calDaysDual(backupTask.endTime, newTask.endTime) != 1);

                if (newTask.price != oldTask.price && !!newTask.price) {
                    // 出价大于预算
                    if (parseFloat(newTask.price) > parseInt(newTask.budget)) {
                        $scope.cfpTaskForm.price.$error.overBudget = true;
                        $scope.cfpTaskForm.price.$invalid = true;
                    } else {
                        delete $scope.cfpTaskForm.price.$error['overBudget'];
                        delete $scope.cfpTaskForm.budget.$error['overPrice'];
                    }
                    //去除错误样式
                    if ($scope.cfpTaskForm.price.$invalid && isEmptyObj($scope.cfpTaskForm.price.$error)) {
                        $scope.cfpTaskForm.price.$invalid = false;
                    }
                    if ($scope.cfpTaskForm.budget.$invalid && isEmptyObj($scope.cfpTaskForm.budget.$error)) {
                        $scope.cfpTaskForm.budget.$invalid = false;
                    }
                } else if (newTask.budget != oldTask.budget && !!newTask.budget) {
                    // 预算小于出价
                    if (parseFloat(newTask.price) > parseInt(newTask.budget)) {
                        $scope.cfpTaskForm.budget.$error.overPrice = true;
                        $scope.cfpTaskForm.budget.$invalid = true;
                    } else {
                        delete $scope.cfpTaskForm.price.$error['overBudget'];
                        delete $scope.cfpTaskForm.budget.$error['overPrice'];
                    }
                    var old_budget = oldTask.oldBudget ? oldTask.oldBudget : 0;
                    if (parseInt(newTask.budget) > (parseFloat(Model.balance) + old_budget)) {
                        $scope.cfpTaskForm.budget.$error.overBalance = true;
                        $scope.cfpTaskForm.budget.$invalid = true;
                    } else {
                        delete $scope.cfpTaskForm.budget.$error['overBalance'];
                    }
                    if (newTask.status == 'RUN' && parseInt(newTask.budget) < $scope.CreateNewModel.CloudFolderTask.oldBudget) {
                        $scope.cfpTaskForm.budget.$error.overBefore = true;
                        $scope.cfpTaskForm.budget.$invalid = true;
                    } else {
                        delete $scope.cfpTaskForm.budget.$error['overBefore'];
                    }
                    //去除错误样式
                    if ($scope.cfpTaskForm.price.$invalid && isEmptyObj($scope.cfpTaskForm.price.$error)) {
                        $scope.cfpTaskForm.price.$invalid = false;
                    }
                    if ($scope.cfpTaskForm.budget.$invalid && isEmptyObj($scope.cfpTaskForm.budget.$error)) {
                        $scope.cfpTaskForm.budget.$invalid = false;
                    }
                } else {
                    delete $scope.cfpTaskForm.price.$error['overBudget'];
                    delete $scope.cfpTaskForm.budget.$error['overPrice'];
                    delete $scope.cfpTaskForm.budget.$error['overBalance'];
                    delete $scope.cfpTaskForm.budget.$error['overBefore'];
                    //去除错误样式
                    if ($scope.cfpTaskForm.price.$invalid && isEmptyObj($scope.cfpTaskForm.price.$error)) {
                        $scope.cfpTaskForm.price.$invalid = false;
                    }
                    if ($scope.cfpTaskForm.budget.$invalid && isEmptyObj($scope.cfpTaskForm.budget.$error)) {
                        $scope.cfpTaskForm.budget.$invalid = false;
                    }
                }

                // 时间
                if (newTask.startTime && oldTask.startTime && newTask.endTime && oldTask.endTime) {
                    if (AUI.DateUtil.date2Str(newTask.startTime) != AUI.DateUtil.date2Str(oldTask.startTime)) {

                        if (AUI.DateUtil.calDaysDual(newTask.endTime, newTask.startTime) < 1) {
                            delete $scope.cfpTaskForm.startTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.startTime.$error['lessTime'];
                            $scope.cfpTaskForm.startTime.$error.overEnd = true;
                            $scope.cfpTaskForm.startTime.$dirty = true;
                            $scope.cfpTaskForm.startTime.$invalid = true;
                        } else if (AUI.DateUtil.calDaysDual(newTask.endTime, newTask.startTime) < Model.minPeriod) {
                            delete $scope.cfpTaskForm.startTime.$error['overEnd'];
                            delete $scope.cfpTaskForm.startTime.$error['moreTime'];
                            $scope.cfpTaskForm.startTime.$error.lessTime = true;
                            $scope.cfpTaskForm.startTime.$dirty = true;
                            $scope.cfpTaskForm.startTime.$invalid = true;
                        } else if (AUI.DateUtil.calDaysDual(newTask.endTime, newTask.startTime) > Model.maxPeriod) {
                            delete $scope.cfpTaskForm.startTime.$error['overEnd'];
                            delete $scope.cfpTaskForm.startTime.$error['lessTime'];
                            $scope.cfpTaskForm.startTime.$error.moreTime = true;
                            $scope.cfpTaskForm.startTime.$dirty = true;
                            $scope.cfpTaskForm.startTime.$invalid = true;
                        } else {
                            delete $scope.cfpTaskForm.startTime.$error['overEnd'];
                            delete $scope.cfpTaskForm.startTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.startTime.$error['lessTime'];
                            delete $scope.cfpTaskForm.endTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.endTime.$error['lessTime'];
                            $scope.cfpTaskForm.startTime.$invalid = false;
                            $scope.cfpTaskForm.endTime.$invalid = false;
                        }
                    } else if (AUI.DateUtil.date2Str(newTask.endTime) != AUI.DateUtil.date2Str(oldTask.endTime)) {

                        if (AUI.DateUtil.calDaysDual(newTask.endTime, new Date()) < 1) {
                            delete $scope.cfpTaskForm.endTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.endTime.$error['lessTime'];
                            $scope.cfpTaskForm.endTime.$error.beforeToday = true;
                            $scope.cfpTaskForm.endTime.$dirty = true;
                            $scope.cfpTaskForm.endTime.$invalid = true;
                        } else if (AUI.DateUtil.calDaysDual(newTask.endTime, newTask.startTime) < Model.minPeriod) {
                            delete $scope.cfpTaskForm.endTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.endTime.$error['beforeToday'];
                            $scope.cfpTaskForm.endTime.$error.lessTime = true;
                            $scope.cfpTaskForm.endTime.$dirty = true;
                            $scope.cfpTaskForm.endTime.$invalid = true;
                        } else if (AUI.DateUtil.calDaysDual(newTask.endTime, newTask.startTime) > Model.maxPeriod) {
                            delete $scope.cfpTaskForm.endTime.$error['lessTime'];
                            delete $scope.cfpTaskForm.endTime.$error['beforeToday'];
                            $scope.cfpTaskForm.endTime.$error.moreTime = true;
                            $scope.cfpTaskForm.endTime.$dirty = true;
                            $scope.cfpTaskForm.endTime.$invalid = true;
                        } else {
                            delete $scope.cfpTaskForm.startTime.$error['overEnd'];
                            delete $scope.cfpTaskForm.startTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.startTime.$error['lessTime'];
                            delete $scope.cfpTaskForm.endTime.$error['beforeToday'];
                            delete $scope.cfpTaskForm.endTime.$error['moreTime'];
                            delete $scope.cfpTaskForm.endTime.$error['lessTime'];
                            $scope.cfpTaskForm.startTime.$invalid = false;
                            $scope.cfpTaskForm.endTime.$invalid = false;
                        }
                    }
                }
                $scope.status = "changed";
            }, true);

            // 有时候弹出多个错误框
            setInterval(function () {
                if (angular.element("#cfpTask").length > 0 && angular.element(".dialog-cover").length > 1) {
                    angular.element(".icon-close").eq(0).click();
                }
            }, 10);
        }
    ]);
})
;

